import React from "react";

const ProductModal = () => {
  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content pb-3 pe-3">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <div className="container">
              <div className="row gy-5">

                {/* Left Image */}
                <div className="col-xxl-6">
                  <div className="modal-thumb">
                    <div className="product-big-img bg-color2">
                      <div className="dishes-thumb">
                        <img
                          className="img-fluid"
                          src="assets/img/dishes/dishes3_1.png"
                          alt="thumb"
                        />
                        <div className="circle-shape">
                          <img
                            className="cir36"
                            src="assets/img/food-items/circleShape2.png"
                            alt="shape"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Content */}
                <div className="col-xxl-6">
                  <div className="modal-details">
                    <div className="product-about">

                      <div className="title-wrapper">
                        <h2 className="product-title">Chicken Pizza</h2>
                        <div className="price">$69</div>
                      </div>

                      <div className="product-rating">
                        <div
                          className="star-rating"
                          role="img"
                          aria-label="Rated 5.00 out of 5"
                        >
                          <span style={{ width: "100%" }}>
                            Rated <strong className="rating">5.00</strong> out
                            of 5 based on{" "}
                            <span className="rating">1</span> customer rating
                          </span>
                        </div>

                        <a
                          href="shop-details.html"
                          className="woocommerce-review-link"
                        >
                          (<span className="count">2</span> customer reviews)
                        </a>
                      </div>

                      <p className="text">
                        Aliquam hendrerit a augue insuscipit. Etiam aliquam massa
                        quis des mauris commodo venenatis ligula commodo leez sed
                        blandit convallis dignissim onec vel pellentesque neque.
                      </p>

                      {/* Actions */}
                      <div className="actions">
                        <div className="quantity">
                          <p>Quantity</p>

                          <div className="qty-wrapper">
                            <button className="quantity-plus qty-btn">
                              <i className="fa-solid fa-plus"></i>
                            </button>

                            <input
                              type="number"
                              className="qty-input"
                              step="1"
                              min="1"
                              max="100"
                              name="quantity"
                              defaultValue="1"
                              title="Qty"
                            />

                            <button className="quantity-minus qty-btn">
                              <i className="fa-solid fa-minus"></i>
                            </button>
                          </div>
                        </div>

                        <a href="cart.html" className="theme-btn">
                          Add to Cart{" "}
                          <i className="fa-regular fa-cart-shopping bg-transparent text-white"></i>
                        </a>

                        <a
                          href="wishlist.html"
                          className="theme-btn style5 border-0"
                        >
                          ADD TO wishlist{" "}
                          <i className="fa-sharp fa-solid fa-heart"></i>
                        </a>
                      </div>

                      {/* Share */}
                      <div className="share">
                        <h6>share with friends</h6>
                        <ul className="social-media">
                          <li>
                            <a href="https://www.facebook.com">
                              <i className="fa-brands fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.youtube.com">
                              <i className="fa-brands fa-youtube"></i>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.x.com">
                              <i className="fa-brands fa-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.instagram.com">
                              <i className="fa-brands fa-instagram"></i>
                            </a>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
